import {Component} from '@wonderlandengine/api';
import {CursorTarget} from '@wonderlandengine/components';
import type {GameAnalytics as GA} from 'gameanalytics';
declare var GameAnalytics: typeof GA;

/**
 * button-share
 */
export class ButtonShare extends Component {
    static TypeName = 'button-share';

    start() {
        const target = this.object.getComponent(CursorTarget)!;
        target.onClick.add(this.onClick);
    }

    onClick = () => {
        GameAnalytics.addDesignEvent('game:button-share');
        this.engine.xr?.session.end().then(() => {
            GameAnalytics.addDesignEvent('share:start');
            navigator
                .share({
                    title: 'WebXR Paintball',
                    text: 'Join me on a game of Paintball in the browser!',
                    url: 'https://heyvr.io/arcade/games/paintball',
                })
                .then(() => {
                    GameAnalytics.addDesignEvent('share:success');
                })
                .catch(() => {
                    GameAnalytics.addDesignEvent('share:cancel');
                });
        });
    };
}
